const _tablet = "640px"
const _laptop = "1024px"
const _desktop = "1280px"
const _desktopLarge = "1440px"
const config = { "tablet": _tablet, "laptop": _laptop, "desktop": _desktop, "desktopLarge": _desktopLarge,  }
export { config as default, _tablet, _laptop, _desktop, _desktopLarge }